import { Stack, Text } from '@mantine/core';
import { useTheme } from '@contexts/ThemeContext';
import { useLanguage } from '@contexts/LanguageContext';
import SidebarFilm from '../SidebarFilm';
import { resolveFirstLoginCopy } from '../i18n';
import type { FilmCopyVariant, FilmVariant } from '../types';

interface StepFilmProps {
  variant: FilmVariant;
  copy: FilmCopyVariant;
}

/** Last step: nothing to fill in. Shows where things live in the real sidebar. */
export default function StepFilm({ variant, copy }: StepFilmProps) {
  const { colors: themeColors } = useTheme();
  const { language } = useLanguage();
  const t = (key: string) => resolveFirstLoginCopy(language, key);

  return (
    <Stack gap="md">
      <div>
        <Text component="h3" fw={700} style={{ color: themeColors.text, fontSize: 22, margin: 0, lineHeight: 1.2 }}>
          {t(`film.${copy}.heading`)}
        </Text>
        <Text size="sm" style={{ color: themeColors.textSecondary, marginTop: 6 }}>
          {t(`film.${copy}.lead`)}
        </Text>
      </div>
      <SidebarFilm variant={variant} caption={t(`film.${copy}.caption`)} />
    </Stack>
  );
}
